var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('ul',{class:_vm.$style.wrapper},_vm._l((_vm.errors),function(error,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(error.message)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }